import React from "react";
export var usePreviousProps = function usePreviousProps(props) {
  var ref = React.useRef();
  React.useEffect(function () {
    ref.current = props;
  });
  return ref.current || {};
};